<template>
    <div class="my-5 p-3">
        <div class="col-12 mb-5">
            <h2 v-html="header" class="text-white pb-4"></h2>
        </div>

        <div class="row">
            <div class="col-md-6 col-xl-4 mb-5" v-for="payment in payments">
                <div class="card border-0 bg-transparent">
                    <div>
                        <img v-bind:src="payment['smallImage']" class="card-img-top text-center" :alt="payment['name']">
                    </div>

                    <div class="card-body">
                        <h5 class="card-title text-white text-center">
                            <span v-html="payment['name']">
                            </span>
                        </h5>
                        <h5 class="card-title text-white text-center">
                            <span v-html="'Cena: '+payment['amount'] + 'zł'">
                            </span>
                        </h5>

                        <div class="event-tags text-center">
                            <form @submit.prevent="generateInvoice(payment['id'])" method="get">
                                <button type="submit" class="btn btn-primary shadow-sm"><i
                                class="fas fa-sm text-white-50"></i>Pobierz fakturę</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <h3 class="text-center text-white font-italic" v-if="payments.length == 0"> <u> Aktualnie nie posiadasz żadnej faktury do pobrania. </u> </h3>

        <nav v-if="pagination.last_page > 1" aria-label="stronicowanie">
            <ul class="pagination justify-content-center">
                <li v-if="page > 1" class="page-item">
                    <a class="page-link" href="#" v-on:click="setPage(page - 1)" aria-label="Poprzednia">
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>
                <li v-for="n in pagination.last_page" :class="'page-item' + (n == page ?  ' active ' : '')" aria-current="page" :key="n">
                    <a class="page-link" href="#" v-on:click="setPage(n)" v-html="n"></a>
                </li>
                <li v-if="page < pagination.last_page" class="page-item">
                    <a class="page-link" href="#" v-on:click="setPage(page + 1)" aria-label="Następna">
                        <span aria-hidden="true">&raquo;</span>
                    </a>
                </li>
            </ul>
        </nav>

        <notifications group="foo" />

    </div>
</template>

<script>
    import Spinner from 'vue-simple-spinner';

    export default {
        props: ['header'],

        components: {
            Spinner
        },
        data() {
            return {
                payments: [],
                pagination: [],
                page: 1,
                perPage: 1,
            }
        },

        created() {
            this.fetchData();
        },

        methods: {
            fetchData(){
                axios.get('/api/user-data/payments', {
                    params: {
                        page: this.page,
                    }
                })
                .then((response) => {
                    this.payments = response.data.data;
                    this.pagination = response.data.meta;
                    this.perPage = response.data.meta.per_page;
                });
            },

            generateInvoice(paymentId){
                axios({
                    url: '/api/user-data/'+paymentId+'/get-invoice',
                    method: 'GET',
                    responseType: 'blob',
                })
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'faktura.pdf');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.$notify({
                        'group': 'foo',
                        'type': 'success',
                        'title': 'Faktura została pobrana pomyślnie'
                    });
                });
            },

            setPage(page) {
                this.page = page;
                this.fetchData();
            },

        }

    }
</script>

